import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import {useRecommendedParticipantsFilter} from '../../../../../../data/hooks/participant/useRecommendedParticipantsFilter';
import Tab from '../../../../../elements/Tabs/Tab';
import {isSuggestedParticipantsTabSelected} from './isSuggestedParticipantsTabSelected';
import { isSuggestedParticipantsTabVisible } from './isSuggestedParticipantsTabVisible';
import { useHashTriggeredEffect } from '../../../../../../misc/useHashTriggeredEffect/useHashTriggeredEffect';

export const HASHTRIGGER_OPEN_SUGGESTED_PARTICIPANTS = 'openSuggestedParticipants';

/**
 * Renders a suggested participants tab component.
 *
 * @param {Object} props - The component props.
 * @param {string} props.eventId - The ID of the event.
 * @param {Object} props.filterParams - The filter parameters.
 * @return {JSX.Element|null} The suggested participants tab component or null if it is not visible.
 */
function SuggestedParticipants(props) {
    const {eventId, filterParams} = props,
        i18n = useI18n(),
        suggestedFilterParams = useRecommendedParticipantsFilter(eventId),
        selected = isSuggestedParticipantsTabSelected(filterParams, suggestedFilterParams),
        dispatch = useDispatch();

    const openSuggestedParticipants = useCallback(() => {
        dispatch(app.actions.participants.setFilterParams(eventId, suggestedFilterParams));
    }, [eventId, suggestedFilterParams]);

    useHashTriggeredEffect(HASHTRIGGER_OPEN_SUGGESTED_PARTICIPANTS, openSuggestedParticipants);

    if (!isSuggestedParticipantsTabVisible(suggestedFilterParams)) return null;

    return (
        <Tab href={`/events/${eventId}/participants`} selected={selected} onClick={openSuggestedParticipants}>
            {i18n['label.tab.recommended']}
        </Tab>
    );
}

export default SuggestedParticipants;
